<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [closable]="false"
  [blockScroll]="true"
  appendTo="body"
  styleClass="client-appointment-details-drawer"
>
  <ng-template #header>
    <div class="flex align-items-start justify-content-between w-full">
      <div class="flex flex-column gap-1">
        <div class="text-lg-semibold text-gray-900">Detalji</div>
        <div class="text-sm-regular text-gray-600">Pogledajte detalje termina</div>
      </div>
      <div class="flex justify-content-center align-items-center cursor-pointer close-btn" (click)="close()">
        <app-x-close stroke="#ADB0B8" width="12" height="12"></app-x-close>
      </div>
    </div>
  </ng-template>

  @if (details(); as d) {
    <div class="drawer-body flex flex-column gap-4 px-4 pb-4 pt-4">
      <!-- STATUS -->
      @if (state() === 'cancelled') {
        <div class="cancelled-banner flex align-items-center gap-3 p-3">
          <div class="banner-icon flex justify-content-center align-items-center">
            <app-slash-circle-01 stroke="#F04438"></app-slash-circle-01>
          </div>
          <div class="flex flex-column gap-1">
            <div><p-chip label="Otkazan" styleClass="red sm"></p-chip></div>
            @if (d.from) {
              <div class="text-sm-medium text-gray-700">{{ getDateFormatedSrWithTime(d.from) }}</div>
            }
          </div>
        </div>
      } @else {
        <div>
          <p-chip [label]="statusLabel()" [styleClass]="statusChipClass()"></p-chip>
        </div>
      }

      <!-- SVI DETALJI -->
      <div class="flex flex-column gap-3">
        <div class="text-md-semibold text-gray-900">Svi detalji</div>
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-2">
            <app-calendar stroke="#ADB0B8"></app-calendar>
            <div class="text-sm-regular text-gray-600">Datum</div>
          </div>
          <div class="text-sm-medium text-gray-700">{{ getDateFormatedSrLong(d.from!) }}</div>
        </div>
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-2">
            <app-clock stroke="#ADB0B8"></app-clock>
            <div class="text-sm-regular text-gray-600">Vreme</div>
          </div>
          <div class="text-sm-medium text-gray-700">{{ formatTimeRange(d.from, d.to) }}</div>
        </div>
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-2">
            <app-hourglas-03 stroke="#ADB0B8"></app-hourglas-03>
            <div class="text-sm-regular text-gray-600">Trajanje</div>
          </div>
          <div class="text-sm-medium text-gray-700">{{ d.duration }}h</div>
        </div>
      </div>

      <!-- PLAN PROJEKCIJE -->
      @if (state() === 'scheduled' || pdfDoc() || autoCadDoc()) {
      <hr class="section-divider" />
      <div class="flex flex-column gap-3">
        <div class="flex align-items-center justify-content-between">
          <div class="text-md-semibold text-gray-900">Plan projekcije</div>
          @if (state() === 'scheduled') {
            <a class="flex align-items-center gap-1 instructions-link" href="#">
              <span class="text-sm-semibold">Uputstvo za pripremu fajla</span>
              <app-link-external-02 stroke="#1570EF" width="14px" height="14px"></app-link-external-02>
            </a>
          }
        </div>

        @if (state() === 'scheduled' && isFileMissing()) {
          <div class="warning-banner flex align-items-start gap-2 p-2">
            <app-alert-triangle stroke="#F79009" width="16px" height="16px"></app-alert-triangle>
            <div class="text-sm-medium text-orange-900">
              Fajl(ove) je potrebno dostaviti najkasnije 24 sata pre termina.
            </div>
          </div>
        }

        <!-- PDF -->
        @if (state() === 'scheduled' || pdfDoc()) {
        <div class="flex flex-column gap-2">
          <div class="text-sm-medium text-gray-700">PDF fajl</div>
          @if (pdfDoc(); as pdf) {
            <div class="file-row flex align-items-center justify-content-between gap-3 px-3 py-2">
              <div class="flex align-items-center gap-2">
                <app-pdf height="40px" width="32px"></app-pdf>
                <div class="flex flex-column">
                  <div class="text-sm-medium text-gray-700">{{ pdf.name }}</div>
                  <div class="text-sm-regular text-gray-600">{{ formatFileSize(pdf.size) }}</div>
                </div>
              </div>
              @if (canDeleteFile()) {
                <i class="pi pi-trash text-red-500 cursor-pointer" (click)="deleteDocument(pdf)"></i>
              }
            </div>
          } @else if (state() === 'scheduled') {
            <div class="empty-file-row bg-gray-50 flex align-items-center justify-content-between gap-2 p-3">
              <div class="text-sm-regular text-gray-500">PDF fajl nije dodat</div>
              <a class="flex align-items-center gap-1 instructions-link cursor-pointer" (click)="pdfInput.click()">
                <span class="text-md-bold">+</span>
                <span class="text-sm-semibold">Dodaj fajl</span>
              </a>
              <input #pdfInput type="file" accept=".pdf,application/pdf" hidden (change)="onFileSelected($event, 'pdf')" />
            </div>
          }
        </div>
        }

        <!-- AutoCAD -->
        @if (state() === 'scheduled' || autoCadDoc()) {
          <div class="flex flex-column gap-2">
            <div class="text-sm-medium text-gray-700">AutoCAD fajl</div>
            @if (autoCadDoc(); as dwg) {
              <div class="file-row flex align-items-center justify-content-between gap-3 px-3 py-2">
                <div class="flex align-items-center gap-2">
                  <app-dwg height="40px" width="32px"></app-dwg>
                  <div class="flex flex-column">
                    <div class="text-sm-medium text-gray-700">{{ dwg.name }}</div>
                    <div class="text-sm-regular text-gray-600">{{ formatFileSize(dwg.size) }}</div>
                  </div>
                </div>
                @if (canDeleteFile()) {
                  <i class="pi pi-trash text-red-500 cursor-pointer" (click)="deleteDocument(dwg)"></i>
                }
              </div>
            } @else {
              <div class="empty-file-row bg-gray-50 flex align-items-center justify-content-between gap-2 p-3">
                <div class="text-sm-regular text-gray-500">AutoCAD fajl nije dodat</div>
                <a class="flex align-items-center gap-1 instructions-link cursor-pointer" (click)="dwgInput.click()">
                  <span class="text-md-bold">+</span>
                  <span class="text-sm-semibold">Dodaj fajl</span>
                </a>
                <input #dwgInput type="file" accept=".dwg,.dxf" hidden (change)="onFileSelected($event, 'autoCad')" />
              </div>
            }
          </div>
        }
      </div>
      }

      <!-- POLITIKA OTKAZIVANJA — pinned to bottom of body -->
      @if (state() === 'scheduled') {
        <div class="flex align-items-start gap-2 mt-auto">
          <app-info-circle stroke="#0BA5EC" width="16px" height="16px"></app-info-circle>
          <div class="flex flex-column gap-1">
            <div class="text-sm-semibold text-gray-700">Politika otkazivanja</div>
            <div class="text-sm-regular text-gray-600">
              Termin se može otkazati najkasnije 48 sati pre početka.
            </div>
          </div>
        </div>
      }
    </div>

    <!-- FOOTER -->
    @if (state() === 'scheduled') {
      <div class="drawer-footer flex align-items-center justify-content-between gap-3 p-4">
        <app-button
          [btnSeverity]="ButtonSeverity.SECONDARY"
          [btnSize]="ButtonSize.MD"
          [isDestructive]="true"
          btnClass="flex-1"
          (btnClicked)="handleCancel()"
        >
          <app-slash-circle-01 stroke="#D92D20"></app-slash-circle-01>
          <div class="text-sm-semibold text-red-600">Otkaži</div>
        </app-button>
        @if (!d.isShortNotice) {
          <app-button
            [btnSeverity]="ButtonSeverity.SECONDARY"
            [btnSize]="ButtonSize.MD"
            btnClass="flex-1"
            (btnClicked)="handleEdit()"
          >
            <app-edit-03 stroke="#181D27"></app-edit-03>
            <div class="text-sm-semibold text-gray-900">Izmeni</div>
          </app-button>
        }
      </div>
    }
  }
</p-drawer>

<app-client-appointment-reschedule-dialog
  [(visible)]="showRescheduleDialog"
  [appointmentId]="appointmentId()"
  (rescheduled)="onRescheduled($event)"
></app-client-appointment-reschedule-dialog>

<app-client-appointment-cancel-dialog
  [(visible)]="showCancelDialog"
  [appointmentId]="appointmentId()"
  (cancelled)="onCancelled($event)"
></app-client-appointment-cancel-dialog>
